import React, { useMemo } from 'react'
import { connect } from 'react-redux'
import { Redirect, Route, RouteProps } from 'react-router'

import { TokenPayloadInterface } from '@store/actionSlices/token'
import { RootStateTypeExtra } from '@store/types'

import VideoScreenSaver from '@components/video-screensaver'
import { useVideoScreensaver } from '@components/video-screensaver/utils'

import { VideoScreensaver } from '@api/config'

import { hasToken } from '@utilities/helper'

export type ProtectedRouteProps = {
  authenticationPath: string
  token: TokenPayloadInterface
  fallbackPath?: string
  isRouteEnabled?: boolean
  videoScreensaver?: VideoScreensaver
} & RouteProps

function ProtectedRoutes({
  authenticationPath,
  token,
  fallbackPath = '/vision',
  isRouteEnabled = true,
  videoScreensaver,
  ...routeProps
}: ProtectedRouteProps) {
  const isAuthenticated = useMemo<boolean>(() => hasToken(token), [token])

  const { showScreensaver } = useVideoScreensaver({
    enabled: !!videoScreensaver?.enabled,
    delay: videoScreensaver?.delay ?? undefined,
    videoUrl: videoScreensaver?.videoUrl ?? undefined,
  })

  if (!isAuthenticated) {
    return <Redirect to={{ pathname: authenticationPath }} />
  }

  if (!isRouteEnabled) {
    return <Redirect to={{ pathname: fallbackPath }} />
  }

  return (
    <>
      {showScreensaver && videoScreensaver?.videoUrl ? (
        <VideoScreenSaver url={videoScreensaver.videoUrl} />
      ) : null}
      <Route {...routeProps} />
    </>
  )
}

export default connect(
  ({ token, projectConfig: { videoScreensaver } }: RootStateTypeExtra) => ({
    token,
    videoScreensaver,
  })
)(ProtectedRoutes)
